@if (title(); as title) {
  <h2>{{ title }}</h2>
}
<lib-interaction-message
  tapMessage="Tap any metric for a detailed breakdown."
  clickMessage="Click on any metric to see breakdown by relevant dimensions."
/>
<div
  #contentScroller
  class="wrapper"
  [class.canScroll]="canScroll$ | async"
>

  <table>
    @let cols = columns();
    @let colsLength = cols.length || 1;
    @let loading = isLoading();
    <tr>
      <th>Measure</th>
      @for (column of cols; track $index) {
        <th>{{ column.columnHeader }}</th>
      }
    </tr>
    <tbody>
      @for (measure of measures(); track measure.code; let mIdx = $index) {
        <tr
          [class.active]="focusMeasure()?.code === measure.code"
          (click)="setFocusMeasure(measure)"
        >
          <td style="width: 30%" class="viewIcon">{{ measure.shortName }}
            @if (measure.classOptions?.suffix; as suffix) {
              <span class="suffix">({{ suffix }})</span>
            }
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
            >
              <use [attr.xlink:href]="viewIcon"></use>
            </svg>
          </td>
          @for (column of cols; track $index; let isLast = $last) {
            @if (loading) {
              <td>...</td>
            } @else {
              @if (chunk(); as chunk) {
                @let showGraph = column.isGraph;
                @let m = column.measures[mIdx] || undefined;
                @let formatMeasure = column.formatMeasures[mIdx] || undefined;
                @let mCode = m?.code || column.measuresCodes[mIdx] || undefined;
                @let focusDataPoint = chunk.dataPoints | selectDataPoint: mCode : periodCode() : date();

                @if (showGraph) {
                  @let graphName = column.graphName || '';
                  <td [title]="mCode" class="barGraph">
                    <lib-bar-minichart
                      [maxNegative]="graphMinMax().get(graphName)?.min"
                      [maxPositive]="graphMinMax().get(graphName)?.max"
                      [value]="focusDataPoint?.value"
                      [isAligned]="measure.alignment === Alignment.Aligned"
                    />
                  </td>
                } @else {
                  <td [title]="mCode" [style.width.%]="(100-30)/colsLength">
                    {{ focusDataPoint?.value | formatByMeasure: formatMeasure : true }}
                  </td>
                }
              }
            }
            @if (isLast) {
              <td class="viewIcon">
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                >
                  <use [attr.xlink:href]="viewIcon"></use>
                </svg>
              </td>
            }
          }
        </tr>
      }
    </tbody>
  </table>
</div>
